export default __webpack_public_path__ + "static/media/Shoes.368ab802.png";